import type { UserData } from "@/types/user-data";

export interface PolicyAcceptanceInput {
  /** Provider behind the current session, from `getCurrentSignInProvider(session.user)`. */
  provider: string | null;
  /** Row from `users`; null when the profile row does not exist yet. */
  userData: UserData | null;
  currentTermsEffectiveDate: string;
  currentPrivacyEffectiveDate: string;
}

/**
 * Whether this session must accept the current Terms and Privacy Policy before
 * entering the app.
 *
 * Only OAuth sessions are gated. Email/OTP users accept inside the login step,
 * which AE-206 leaves untouched — that scoping is what keeps the existing flow
 * regression-free and avoids racing LoginPage's post-verify acceptance write
 * against the profile AuthProvider already loaded.
 *
 * An unknown provider means no gate: an unreadable session must never be able
 * to lock a user out of the product.
 */
export function requiresPolicyAcceptance({
  provider,
  userData,
  currentTermsEffectiveDate,
  currentPrivacyEffectiveDate,
}: PolicyAcceptanceInput): boolean {
  if (!provider || provider === "email") return false;
  if (!userData) return true;
  return (
    userData.terms_effective_date !== currentTermsEffectiveDate ||
    userData.privacy_effective_date !== currentPrivacyEffectiveDate
  );
}
